import 'css-chunksrc/client/common/resourceSelection/resources/styles.scss';export default {
  "resources": "_resources_pbt67_1",
  "pagedResources": "_pagedResources_pbt67_6"
};